import { createContext } from "react";

export const AppContext = createContext({
  formFields: {},
  updateContext: () => {},
  meetingPayload: {},
  setMeetingPayload: () => {},
});
